//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss'
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const sleepPerNight = useStore((state) => state.sleepPerNight);
  const setSleepPerNight = useStore((state) => state.setSleepPerNight);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.sleepPerNight.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={sleepPerNight}
          onChange={(value) => {
            setSleepPerNight(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'sleep-per-night',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Less than 5 hours'}>
            <span>🤪</span> {t('onboarding.sleepPerNight.options.less5')}
          </Option>
          <Option value={'5-6 hours'}>
            <span>🖐</span> {t('onboarding.sleepPerNight.options.6hours')}
          </Option>
          <Option value={'7-8 hours'}>
            <span>👌</span> {t('onboarding.sleepPerNight.options.8hours')}
          </Option>
          <Option value={'More than 8 hours'}>
            <span>😥</span> {t('onboarding.sleepPerNight.options.more8')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
